import axios from "axios";
import { toast } from "react-toastify";
import {
  CREATE_SCHOOL_PERFORMANCE,
  DELETE_SCHOOL_PERFORMANCE,
  GET_ALL_SCHOOL_PERFORMANCE,
  GET_SCHOOL_PERFORMANCE,
  GET_SCHOOL_PERFORMANCE_BATCH,
  GET_STUDENT_SCHOOL_PERFORMANCE,
  UPDATE_SCHOOL_PERFORMANCE,
} from "../constants/Type";
import { BASE_URL } from "../constants/URL";

export const getAllSchoolPerformance =
  (batchId, year, term, gradeId, shiftId) => async (dispatch) => {
    const data = {
      batchId,
      year,
      term,
      gradeId,
      shiftId,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post(
        `${BASE_URL}/api/school-performance/all`,
        JSON.stringify(data),
        config
      );

      dispatch({
        type: GET_ALL_SCHOOL_PERFORMANCE,
        payload: { ...res.data },
      });
      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

export const getSchoolPerformanceResult =
  (startTerm, startYear, endTerm, endYear, studentId, year, gradeId, shiftId, batchId) =>
  async (dispatch) => {
    const data = {
      startTerm,
      startYear,
      endTerm,
      endYear,
      year,
      gradeId,
      shiftId,
      batchId,
      studentId,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post(
        `${BASE_URL}/api/school-performance/between`,
        JSON.stringify(data),
        config
      );

      dispatch({
        type: GET_SCHOOL_PERFORMANCE,
        payload: { ...res.data },
      });
      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

export const getSchoolPerformanceStudentForBatch =
  (year, term, batchId, termCount) => async (dispatch) => {
    const data = {
      year,
      term,
      batchId,
      termCount,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post(
        `${BASE_URL}/api/school-performance/batch`,
        JSON.stringify(data),
        config
      );

      dispatch({
        type: GET_STUDENT_SCHOOL_PERFORMANCE,
        payload: { ...res.data },
      });
      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

export const getBatchSchoolPerformanceResult =
  (year, term, batchId) => async (dispatch) => {
    const data = {
      year,
      term,
      batchId,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post(
        `${BASE_URL}/api/school-performance/batch-res`,
        JSON.stringify(data),
        config
      );

      dispatch({
        type: GET_SCHOOL_PERFORMANCE_BATCH,
        payload: { ...res.data },
      });
      return res.data.data;
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

export const createSchoolPerformance = (term, year, marks) => async (dispatch) => {
  const data = {
    term: parseInt(term),
    marks,
    year: parseInt(year),
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    await axios.post(
      `${BASE_URL}/api/school-performance`,
      JSON.stringify(data),
      config
    );
    dispatch({
      type: CREATE_SCHOOL_PERFORMANCE,
    });
    toast.success("School performance added successfully");

    return true;
  } catch (err) {
    toast.error(err.response.data.message);
    return false;
  }
};

export const editSchoolPerformance = (term, year, marks) => async (dispatch) => {
  const data = {
    term: parseInt(term),
    marks,
    year: parseInt(year),
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    await axios.patch(
      `${BASE_URL}/api/school-performance`,
      JSON.stringify(data),
      config
    );
    dispatch({
      type: UPDATE_SCHOOL_PERFORMANCE,
    });
    toast.success("School performance edited successfully");

    return true;
  } catch (err) {
    toast.error(err.response.data.message);
    return false;
  }
};

export const deleteSchoolPerformance = (id) => async (dispatch) => {
  try {
    await axios.delete(`${BASE_URL}/api/school-performance/${id}`);
    dispatch({
      type: DELETE_SCHOOL_PERFORMANCE,
      payload: id,
    });
    toast.success("School performance deleted successfully");
    return true;
  } catch (err) {
    toast.error(err.response?.data?.message || "Something went wrong");
    return false;
  }
};
